import React, { useState } from "react";

import { toast } from "react-hot-toast";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  Admin_Login_POST,
  Agent_Login_POST,
  Client_Login_POST,
} from "api/ApiConst";
import { callPostApiWithoutAuth } from "api/ApiCaller";
import { PAGE_LOADER } from "utils/constants";
import { LOGIN } from "reducer/actions";
const Login = () => {
  // const { showPageLoader } = useSelector((state) => state.utility);
  const dispatch = useDispatch();
  let location = useLocation();

  const [userDetails, setUserDetails] = useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (userDetails.username === "") {
      toast("Please Enter userName");
      return;
    }
    if (userDetails.password === "") {
      toast("Please Enter Password");
      return;
    }
    // const url =
    //   location.pathname === "/admin-login"
    //     ? Admin_Login_POST
    //     : location.pathname === "/agent-login"
    //     ? Agent_Login_POST
    //     : Client_Login_POST;
    const url = Admin_Login_POST;

    callPostApiWithoutAuth("loader", url, userDetails, (response) => {
      dispatch({ type: LOGIN, payload: response.responsePacket }, []);
    });
  };

  return (
    <div className="account-pages ">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-6 col-xl-5">
            <div className="card overflow-hidden">
              <div className=" bg-black text-center py-4 ">
              <img className="w-25" src="assets/images/logo-login.png" alt="" />
              </div>
              <div className="card-body pt-0">
                <div className="p-2">
                  <form className="form-horizontal">
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">
                        UserName
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="userName"
                        placeholder="UserName"
                        value={userDetails.userName}
                        onChange={(e) =>
                          setUserDetails({
                            ...userDetails,
                            username: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <div className="input-group auth-pass-inputgroup">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          placeholder="Password"
                          value={userDetails.password}
                          onChange={(e) =>
                            setUserDetails({
                              ...userDetails,
                              password: e.target.value,
                            })
                          }
                        />
                        <span
                          className="bg-yellow d-flex justify-content-center  align-items-center py-2 px-3 eye-button"
                          id="password-addon"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <i className="mdi mdi-eye-off-outline" />
                          ) : (
                            <i className="mdi mdi-eye-outline" />
                          )}
                        </span>
                      </div>
                    </div>
                    <hr />
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="remember-check"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="remember-check"
                      >
                        Remember me
                      </label>
                    </div>
                    <div className="mt-3 d-grid">
                      <button
                        className="btn bg-yellow fw-bold "
                        onClick={handleLogin}
                      >
                        Log In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="text-center position-fixed bottom-0 start-0 end-0 ">
              <div>
                {/* <p>
                  Don't have an account ?
                  <a
                    href="auth-register.html"
                    className="fw-medium text-primary"
                  >
                    Signup now
                  </a>
                </p> */}
                <p>©Pyramid 2023 Company All rights reserved</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
